import createReducer from '../utils/createReducer';
import actions from '../actions/multipleAccounts';

const initialState = {};

const actionHandlers = {
    [actions.MULTIPLE_ACCOUNTS_SELECTION_ERROR](state, {payload}) {
        return {
            ...state,
            serviceError: payload.errorKey
        };
    },
    [actions.DISMISS_ALERT_BOX](state, {}) {
        return {
            ...state,
            serviceError: ''
        };
    }
};

export default createReducer(actionHandlers, initialState);
